module.exports = __webpack_public_path__ + "static/img/pic_03@2x.83d805d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_03@2x.png
// module id = xJWk
// module chunks = 2